var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-edicion',[_c('page-header',{attrs:{"title":_vm.descuento.descripcion,"subtitle":"Descuento","back-to":"/descuentos"}}),_c('formulario',{attrs:{"descuento":_vm.descuento},on:{"submit":_vm.actualizar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }